const EMPTY_DATE = '—';

/**
 * Formats a calendar date without allowing an ISO timestamp's timezone to
 * move it to the previous or next day.
 */
export const formatCalendarDate = (value?: Date | string): string => {
    if (!value) {
        return EMPTY_DATE;
    }

    if (typeof value === 'string') {
        const isoDate = /^(\d{4})-(\d{2})-(\d{2})(?:T|$)/.exec(value);
        if (isoDate) {
            const year = Number(isoDate[1]);
            const month = Number(isoDate[2]);
            const day = Number(isoDate[3]);
            const localDate = new Date(year, month - 1, day);

            if (localDate.getFullYear() !== year || localDate.getMonth() !== month - 1 || localDate.getDate() !== day) {
                return EMPTY_DATE;
            }

            return new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            }).format(localDate);
        }
    }

    const date = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(date.getTime())) {
        return EMPTY_DATE;
    }

    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }).format(date);
};



// WEBPACK FOOTER //
// ./src/util/formatCalendarDate.ts